import { render, staticRenderFns } from "./KStatCard.vue?vue&type=template&id=4312ff44&"
import script from "./KStatCard.vue?vue&type=script&lang=js&"
export * from "./KStatCard.vue?vue&type=script&lang=js&"
import style0 from "./KStatCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports